/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgReliabilityLoadBalancer = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.095 10.148L15.25 8l-2.148-2.147-.707.707.933.94h-3.41a2.645 2.645 0 00-.443-1.04L11.842 4l.023 1.328 1-.018-.055-3.03-3.035.058.018 1 1.33-.023L8.75 5.768A2.663 2.663 0 004.678 7.5h-.585a1.585 1.585 0 100 1h.585a2.663 2.663 0 004.072 1.732l2.367 2.456-1.33-.023-.017 1 3.035.058.055-3.036-1-.017-.018 1.33-2.367-2.46c.22-.31.372-.665.443-1.04h3.41l-.94.94.707.708zm-10.5-1.563a.585.585 0 11.41-.172.585.585 0 01-.412.172h.002zM5.63 8a1.67 1.67 0 113.34 0 1.67 1.67 0 01-3.34 0z"
}));

export default SvgReliabilityLoadBalancer;